import { actionPlan } from "./actionPlan"
import { area } from "./area"
import { breadBrumbs } from "./breadCrumbs"
import { catalog } from "./catalog"
import { companie } from "./companie"
import { dashboard } from "./dashboard"
import { department } from "./department"
import { division } from "./division"
import { dropList } from "./dropDownLists"
import { filesManager } from "./filesManager"
import { general } from "./general"
import { localization } from "./localization"
import { loogbook } from "./logbook"
import { login } from "./login"
import { massiveUpload } from "./massiveUpload"
import { optionGroup } from "./optionGroup"
import { questionnaire } from "./questionnaire"
import { reportFolio } from "./reportFolio"
import { routes } from "./routes"
import { schedule } from "./schedule"
import { stores } from "./stores"
import { toolTips } from "./toolTips"
import { user } from "./user"
import { userGroup } from "./userGroup"
import { userSchedule } from "./userSchedule"
import { userType } from "./userType"
import { zones } from "./zones"

const es = {
  general,
  dashboard,
  login,
  stores,
  routes,
  loogbook,
  filesManager,
  dropList,
  "optionGroup": optionGroup,
  "companie": companie,
  "division": division,
  "zones": zones,
  "user": user,
  "userType": userType,
  "area": area,
  "department": department,
  "actionPlan": actionPlan,
  "schedule": schedule,
  "Questionarie": questionnaire,
  "MassiveUpload": massiveUpload,
  "reportFolio": reportFolio,
  "localization": localization,
  "useScheduled": userSchedule,
  "catalog" : catalog,
  "ToolTips": toolTips,
  breadBrumbs,
  userGroup,
}

export default es